import { render, staticRenderFns } from "./MetricModal.vue?vue&type=template&id=34d3bc24&"
import script from "./MetricModal.vue?vue&type=script&lang=js&"
export * from "./MetricModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports